import React from 'react';
import './AboutCertificate.css';
import AboutCertificateImg from '../../Assets/AboutCertificate.jpg';
import { useTranslation } from 'react-i18next';

const AboutCertificate = () => {
  const { t } = useTranslation();

  return (
    <div className="about-certificate-container">
      <div className="about-certificate-content">
        <h2 className='ES-Heading'>{t('AboutTheCertificate')}</h2>
        <p>
          {t('AfterCompletingCourse')}
        </p>

        <h3 className='certificate-details'><strong>{t('HowToGetIt')}</strong></h3>
        <p>
          {t('EnrollInCourse')}{' '}{t('UponCompletion')}
        </p>

        <h3 className='certificate-details'><strong>{t('DigitalFormat')}</strong></h3>
        <p>
          {t('CertificatePDF')}
        </p>

        <h3 className='certificate-details'><strong>{t('WhyImportant')}</strong></h3>
        <p>
          {t('CertificateImportance')}
        </p>
        <h3 className='certificate-details'><strong>{t('Note')}</strong></h3>
        <div className="highlight-note">
          <p>{t('AIInterviewNote')}</p>
        </div>


      </div>
      <div className="about-certificate-image">
        <img src={AboutCertificateImg} alt={t('SampleCertificate')} />
      </div>
    </div>
  );
};

export default AboutCertificate;
